import { render, staticRenderFns } from "./CmsColumn.vue?vue&type=template&id=12f3147f&scoped=true&"
import script from "./CmsColumn.vue?vue&type=script&lang=js&"
export * from "./CmsColumn.vue?vue&type=script&lang=js&"
import style0 from "./CmsColumn.vue?vue&type=style&index=0&id=12f3147f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_l4g5nlw2jejcj23wpoomwoyaia/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3147f",
  null
  
)

export default component.exports